import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../intake/services/common/common.service';

@Component({
    selector: 'app-lockout',
    templateUrl: './lockout.component.html',
    styleUrls: ['./lockout.component.scss']
})
export class LockoutComponent implements OnInit {
    modal_title = "Enter Your Pin";
    lockout_pin = '';
    is_verified = false;
    verified_error = 'Lockout pin is not verified, please verify';
    lockoutSetting: any;
    lockout_type = "";
    constructor(
        private commonService: CommonService,
        public activeModal: NgbActiveModal,
    ) { }

    ngOnInit() {

    }
    closeModal() {
        this.lockout_type = "";
        this.activeModal.close(this.is_verified);
    }
    // lockout_type only selects which message to show; every type verifies
    // against the same single lockout pin.
    verifyLockoutPin(event) {
        if (this.lockoutSetting) {
            this.commonService.getLockoutPin(this.lockout_pin).subscribe(data => {
                this.is_verified = data.success;
                if (this.is_verified) {
                    this.lockout_type = "";
                    this.activeModal.close(this.is_verified);
                }
                else {
                    this.verified_error = data.message;
                }
            });
        }
        else {
            this.is_verified = true;
        }
    }

}
